export default `
{{#> page inner=1 scroll=1}}
  {{> profile action="edit" user=user}}
{{/page}}

`;
